<div *ngIf="aberta" class="modal-backdrop-custom" (click)="fechar.emit()">
  <div class="modal-card modal-captura" (click)="$event.stopPropagation()">
    <div class="modal-header-custom">
      <h3 class="h5 mb-0">{{ titulo }}</h3>
      <button type="button" class="btn btn-light btn-sm" (click)="fechar.emit()" aria-label="Fechar">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="modal-body-custom">
      <div *ngIf="carregando" class="text-secondary">Carregando captura...</div>
      <p *ngIf="!carregando && erro" class="text-danger mb-0">{{ erro }}</p>
      <p *ngIf="!carregando && aviso && url" class="text-secondary small mb-2">{{ aviso }}</p>
      <img *ngIf="!carregando && url" class="captura-ponto" [src]="url" alt="Captura facial da batida">
    </div>
  </div>
</div>
